<template>
    <form class="standard-form" id="CreditCardForm" data-vv-scope="CreditCardForm">
        <v-layout row wrap>
            <v-flex xs12 sm12 md12 lg12 xl12>
                <label for="payment_  method" class="subheading">Payment Method</label>
                <v-overflow-btn
                    id="payment_method"
                    v-model="payment_method"
                    return-object
                    editable 
                    flat
                    outline
                    :items="payment_methods"
                    v-validate="'required'" 
                    :error-messages="errors.first('CreditCardForm.payment_method')"
                    data-vv-name="payment_method"
                    data-vv-scope="CreditCardForm"
                    data-vv-validate-on="blur"
                    class="bggray"
                    disabled
                ></v-overflow-btn>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12 sm12 md12 lg12 xl12>
                <label for="" class="subheading">Card Number</label>
                <v-text-field
                    id="card_number"
                    v-model="card_number"
                    mask="#### #### #### ####"
                    label="E.g. 1234 5678 9012 3456"
                    single-line
                    outline
                    class="full-width"
                    v-validate="'required|min:16|credit_card'" 
                    :error-messages="errors.first('CreditCardForm.card_number')"
                    data-vv-name="card_number"
                    data-vv-scope="CreditCardForm"
                    :class="{valid_entry: fields.$CreditCardForm && fields.$CreditCardForm.card_number && fields.$CreditCardForm.card_number.valid}"
                ></v-text-field>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs6 sm6 md6 lg6 xl6>
                <label for="expiry_date_month" class="subheading">Expiry Date</label>
                <v-overflow-btn
                    id="expiry_date_month"
                    v-model="expiry_date_month"
                    :items="months"
                    label="mm"
                    return-object
                    editable
                    flat
                    outline
                    v-validate="'required'" 
                    :error-messages="errors.first('CreditCardForm.expiry_date_month')"
                    data-vv-name="expiry_date_month"
                    data-vv-scope="CreditCardForm"
                    :class="{valid_entry: fields.$CreditCardForm && fields.$CreditCardForm.expiry_date_month && fields.$CreditCardForm.expiry_date_month.valid}"
                ></v-overflow-btn>
            </v-flex>
            <v-flex xs6 sm md6 lg6 xl6>
                <label for="expiry_date_year" class="subheading">&nbsp;</label>
                <v-overflow-btn
                    id="expiry_date_year"
                    v-model="expiry_date_year"
                    :items="years"
                    label="yyyy"
                    return-object
                    editable
                    flat
                    outline
                    v-validate="'required'" 
                    :error-messages="errors.first('CreditCardForm.expiry_date_year')"
                    data-vv-name="expiry_date_year"
                    data-vv-scope="CreditCardForm"
                    :class="{valid_entry: fields.$CreditCardForm && fields.$CreditCardForm.expiry_date_year && fields.$CreditCardForm.expiry_date_year.valid}"
                ></v-overflow-btn>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs6 sm6 md6 lg6 xl6>
                <label for="security_code" class="subheading">Security Code</label>
                <v-text-field
                    id="security_code"
                    v-model="security_code"
                    single-line
                    outline
                    class="full-width" 
                    label="E.g. 123" 
                    mask="####" 
                    v-validate="'required|max:4'" 
                    :error-messages="errors.first('CreditCardForm.security_code')" 
                    data-vv-name="security_code" 
                    data-vv-scope="CreditCardForm" 
                    :class="{ valid_entry: fields.$CreditCardForm && fields.$CreditCardForm.security_code && fields.$CreditCardForm.security_code.valid }" 
                    @focus="tooltip_security_code = true" 
                    @focusout="tooltip_security_code = false" 
                ></v-text-field> 
                <v-tooltip v-model="tooltip_security_code" right max-width="160px"> 
                    <template v-slot:activator="{ on }">
                        
                    </template>
                    <span>The CVV Number ("Card Verification Value") on your credit card or debit card is a 3 digit number located on the back of your Credit Card.</span> 
                </v-tooltip> 
            </v-flex>
            <v-flex xs6 sm6 md6 lg6 xl6>
                
            </v-flex>
        </v-layout>

        <v-layout row wrap align-center justify-center>
            <v-flex xs12 sm12 md4 lg4 xl4 align-center>
                <v-btn round flat dark class="next-btn" @click="ProcessPayment()" style="width: 100%;" :class="{ next_btn_active: AllFieldsValid }">Confirm Payment<span class="icon-next"><IconBase><IconCheck /></IconBase></span></v-btn>
            </v-flex>
        </v-layout>

    </form>
</template>

<script>
import IconBase from '@/components/IconBase.vue'
import IconForward from '@/components/icons/arrowForward.vue'
import IconCheck from '@/components/icons/check.vue'
import IconInformation from '@/components/icons/information.vue'
import Globals from '@/assets/scripts/global-functions.js'

export default {
    name: "ComponentCreditCardForm",
    components: {
        IconBase,
        IconForward,
        IconCheck,
        IconInformation,
        Globals
    },
    props: ['role'],
    data: () => ({
        payment_method: "Credit Card",
        card_number: "",
        expiry_date_month: "",
        expiry_date_year: "",
        security_code: "",
        amount: 0,
        tooltip_security_code: false,
        payment_methods: ["Credit Card", "Paypal"],
        credit_card_types: ["Visa","MasterCard","American Express","Visa Electron"],
        months: [],
        years: [],
        dictionary: {
            custom: {
                payment_method: {
                    required: () => "This field is required to proceed."
                },
                card_number: {
                    required: () => "This field is required to proceed.",
                    min: "Credit card number cannot be less than 16 characters",
                    credit_card: "You have entered an invalid credit card number"
                },
                expiry_date_month: {
                    required: () => "This field is required to proceed."
                },
                expiry_date_year: {
                    required: () => "This field is required to proceed."
                },
                security_code: {
                    required: () => "This field is required to proceed.",
                    max: "Security code cannot be more than 4 characters"
                }
            }
        }
    }),
    computed: {
        AllFieldsValid: function() {
            /*
            Function:
            ► Returns boolean 
            ► Check if all entered fields are valid
            ► This computed functions is used in Next button (will highlight more if all fields are valid)
            */
            let _isvalid = false;
            if(this.fields.$CreditCardForm) {
                let fld = this.fields.$CreditCardForm;
                if(fld.card_number.valid && fld.expiry_date_month.valid && fld.expiry_date_year.valid && fld.security_code.valid) {         _isvalid = true; 
                }
            }
            return _isvalid;
        }
    },
    methods: {
        ProcessPayment() {
            this.$validator.validateAll("CreditCardForm").then((result) => {
                if(result) {
                    if(this.role == "educator") {
                        window.location = "/educator/confirmation"
                    } else {
                        alert("service payment process in progress")
                    }
                }
            })
        }
    },
    mounted () {
        this.$validator.localize('en', this.dictionary) 
        this.years = Globals.CreateNumberArray(new Date().getFullYear(),10);
        this.months = Globals.CreateNumberArray(1,11);
    }
}
</script>

<style lang="scss" scoped>
    .standard-form .v-input.bggray  .v-input__slot{
        background-color: #AAAAAA !important; /* forced overlay */
    }
</style>
